<template>
  <div v-if="entryVerified" class="delete-account-success">
    <main>
      <span class="delete-account-success__icon">
        <span><img src="@/assets/img/profile/account/success.svg" alt=""></span>
        <i><img src="@/assets/img/profile/account/home.svg" alt=""></i>
      </span>
      <h1>{{ $t('deleteAccount.successTitle') }}</h1>
      <p>{{ $t('deleteAccount.successDescription') }}</p>
      <button type="button" @click="goHome">
        {{ $t('deleteAccount.goHome') }}
      </button>
    </main>
  </div>
</template>

<script>
const DELETE_ACCOUNT_COMPLETED_KEY = 'accountDeleteCompleted';

export default {
  name: 'ProfileDeleteAccountSuccess',
  data() {
    return {
      entryVerified: false,
      clearTimer: null,
      accountCleared: false,
    };
  },
  created() {
    if (sessionStorage.getItem(DELETE_ACCOUNT_COMPLETED_KEY) !== '1') {
      sessionStorage.setItem('isGoBack', 'true');
      this.$router.replace('/index');
      return;
    }
    this.entryVerified = true;
  },
  mounted() {
    if (!this.entryVerified) return;
    window.addEventListener('pagehide', this.clearLocalAccount);
    this.clearTimer = window.setTimeout(() => {
      this.clearLocalAccount();
    }, 600);
  },
  beforeDestroy() {
    window.removeEventListener('pagehide', this.clearLocalAccount);
    this.clearLocalAccount();
  },
  methods: {
    clearLocalAccount() {
      if (!this.entryVerified || this.accountCleared) return;
      this.accountCleared = true;
      window.removeEventListener('pagehide', this.clearLocalAccount);
      if (this.clearTimer) window.clearTimeout(this.clearTimer);
      this.clearTimer = null;
      sessionStorage.removeItem(DELETE_ACCOUNT_COMPLETED_KEY);
      this.$store.dispatch('user/clearLogin');
    },
    goHome() {
      this.clearLocalAccount();
      sessionStorage.setItem('isGoBack', 'true');
      this.$router.replace('/index');
    },
  },
};
</script>

<style lang="less" scoped>
.delete-account-success {
  min-height: 100vh;
  padding: 240px 16px 48px;
  background: linear-gradient(180deg, #ffffff 0%, #f4f8ff 100%);
  color: #070d3f;
  box-sizing: border-box;

  main {
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
  }

  h1 {
    margin: 56px 0 0;
    font-size: 30px;
    font-weight: 600;
    line-height: 44px;
  }

  p {
    max-width: 620px;
    margin: 24px 40px 0;
    color: #6b7280;
    font-size: 26px;
    line-height: 36px;
  }

  button {
    width: calc(100% - 112px);
    max-width: 640px;
    height: 92px;
    margin-top: 152px;
    border: 0;
    border-radius: 20px;
    background: linear-gradient(90deg, #0b45ff, #2778ff);
    color: #ffffff;
    font-size: 30px;
    font-weight: 500;
  }
}

.delete-account-success__icon {
  position: relative;
  display: flex;
  width: 256px;
  height: 256px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #eaf3ff;
  color: #0b45ff;
  font-size: 164px;

  > span {
    display: flex;
    width: 164px;
    height: 164px;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    background: linear-gradient(180deg, rgba(11, 69, 255, 0.78), #0b45ff);

    img {
      width: 88px;
      height: 88px;
    }
  }

  > i {
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    width: 84px;
    height: 84px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #0b45ff;
    color: #ffffff;
    font-size: 48px;
    font-style: normal;

    img {
      width: 48px;
      height: 48px;
    }
  }
}
</style>
